// Modal para gerar um novo pagamento.

import React, { useState } from "react";
import axios from "axios";

const NovoPrazoModal = ({ idProcess }) => {
    const [descricao, setDescricao] = useState("");
    const [dataPrazo, setDataPrazo] = useState("");

    // Função para criação de novo prazo
    function novoPrazo() {        
        axios
            .post(`/api/new/deadline/${idProcess}`, {descricao, dataPrazo}, { // Rota simulada para criação de novo prazo
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((resp) => {
                window.location.reload()
            }
            );
    }

    return (
        <div
            className="modal fade"
            id="prazoModal"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div
                className="modal-dialog"
                role="document"
                style={{ marginTop: "70px" }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Gerar Novo Prazo para Envio de Comprovante
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <label htmlFor="descricao_novo">
                            Informe a Descrição do Prazo que deseja criar
                        </label>
                        <textarea
                            className="form-control"
                            id="descricao_novo"
                            rows="3"
                            name="descricao"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                        ></textarea>
                        <label
                            className="required"
                            htmlFor="data_prazo_novo"
                        >
                            Informe a data do Prazo
                        </label>
                        <div
                            className="input-group date"
                            id="deadlineDate"
                            data-target-input="nearest"
                        >
                            <input
                                type="date"
                                id="data_prazo_novo"
                                className="form-control datetimepicker-input"
                                data-target="#deadlineDate"
                                name="data"
                                value={dataPrazo}
                                onChange={(e) => setDataPrazo(e.target.value)}
                            />
                        </div>
                        
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={novoPrazo}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoPrazoModal;
